import { atom } from "recoil";
import { INoteCategory } from "../types/NoteCategory";
import { ContactNote } from "../types/NoteTypes";

export const ContactNotesAtom = atom<ContactNote[]>({
    key: "ContactNote",
    default: [],
});

export const NoteCategoriesAtom = atom<INoteCategory[]>({
    key: "NoteCategories",
    default: [],
});
